module.exports = __webpack_public_path__ + "static/media/step2_14_m.6f05f33b.png";